import React from 'react';

import ManageProduct from '../ManageProduct/ManageProduct';

export default function NewProduct() {
  return <ManageProduct title="New product" />;
}
